import React from 'react';
import { ArrowRightIcon, TagIcon } from 'lucide-react';
interface CTAButtonEMFEVProps {
  productName?: string;
  regularPrice?: string;
  salePrice?: string;
  discount?: string;
  url?: string;
  trackingName?: string;
}
const CTAButtonEMFEV: React.FC<CTAButtonEMFEVProps> = ({
  productName = 'EMF Shield Pro - EV Cabin Protector',
  regularPrice = '$199.99',
  salePrice = '$99.99',
  discount = '$100 OFF',
  url = 'https://offer.odinemf.com/safewave/checkout-v1?oid=123&affid=23&uid=2898&oidab=811&affidab=877',
  trackingName = 'EMF Shield Pro EV Cabin Protector'
}) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    // Facebook Pixel tracking (fire-and-forget)
    setTimeout(() => {
      try {
        if (typeof window !== 'undefined' && (window as any).fbq) {
          ;
          (window as any).fbq('track', 'Advertorial_ClickToOffer', {
            content_name: trackingName,
            content_category: 'Health',
            value: parseFloat(salePrice.replace(/[^\d.]/g, ''))
          });
        }
      } catch (error) {
        console.error('Facebook Pixel tracking error:', error);
      }
    }, 0);
  };
  return <div className="w-full max-w-md mx-auto border border-gray-300 rounded-lg p-4 bg-white" data-id="element-3327">
      <div className="flex items-center gap-1.5 mb-2" data-id="element-3328">
        <TagIcon className="h-3.5 w-3.5 text-gray-600" data-id="element-3329" />
        <span className="text-xs font-medium text-gray-600 uppercase tracking-wide" data-id="element-3330">
          READER ACCESS
        </span>
      </div>

      <h3 className="text-base font-serif font-medium text-gray-900 mb-1.5" data-id="element-3331">
        {productName}
      </h3>

      <div className="flex items-center gap-1.5 mb-3" data-id="element-3332">
        <span className="text-sm text-gray-400 line-through" data-id="element-3333">
          {regularPrice}
        </span>
        <span className="text-base font-medium text-green-600" data-id="element-3334">
          {salePrice}
        </span>
        <span className="bg-yellow-100 text-yellow-800 text-xs font-semibold px-2.5 py-1 rounded" data-id="element-3335">
          {discount}
        </span>
      </div>

      <a href={url} onClick={handleClick} target="_blank" rel="noopener noreferrer" className="block w-full bg-gray-900 hover:bg-gray-800 text-white font-medium text-base py-3 px-6 rounded transition-colors duration-200 text-center" data-id="element-3336">
        <span className="flex items-center justify-center gap-2" data-id="element-3337">
          Access Offer
          <ArrowRightIcon className="h-4 w-4" data-id="element-3338" />
        </span>
      </a>
    </div>;
};
export default CTAButtonEMFEV;